import React from 'react';
import { SearchBar } from './SearchBar';
interface HelpHeroProps {
  title?: string;
  subtitle?: string;
  showSearch?: boolean;
}
export function HelpHero({
  title = 'Hola, ¿Cómo te podemos ayudar hoy?',
  subtitle = 'Encuentra respuestas sobre tus pedidos, envíos y medicamentos.',
  showSearch = true
}: HelpHeroProps) {
  return <div className="bg-gradient-to-b from-[#022a3b] to-[#003b54] pt-16 pb-24 px-4 md:px-8 text-center relative overflow-hidden" data-id="element-128">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl" data-id="element-129"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#0af]/10 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl" data-id="element-130"></div>

      <div className="relative z-10 max-w-4xl mx-auto" data-id="element-131">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight" data-id="element-132">
          {title}
        </h1>
        <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-133">
          {subtitle}
        </p>

        {showSearch && <SearchBar data-id="element-134" />}
      </div>
    </div>;
}